// removed by extract-text-webpack-plugin
module.exports = {"Checkbox":"TableOptions__Checkbox___2sGb_","ChessCheckInner":"TableOptions__ChessCheckInner___20cOw","Switcher":"TableOptions__Switcher___3UeDT","ChessSwitcherButton":"TableOptions__ChessSwitcherButton___2kzrV","ChessText":"TableOptions__ChessText___3kgcG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Chess/TableOptions/TableOptions.scss
// module id = 1359
// module chunks = 0